(function(){
      
/* Guard: disable ajax-mini-cart submit binding when cart-add-modal exists */
if (typeof document !== 'undefined' && document.getElementById('cart-add-modal')) {
// Avoid double add-to-cart: cart-add-modal handles submit on these pages
return;
}
function isAddToCartForm(form){ if(!form) return false; var action=form.getAttribute('action')||''; return action.indexOf('/cart/add')!==-1; }
      function onItemAdded(){ if(window.Shopify&&typeof Shopify.getCart==='function'){ Shopify.getCart(); } }
      function handleSubmit(e){ var form=e.target; if(!isAddToCartForm(form)) return; e.preventDefault(); jQuery.ajax({type:'POST',url:'/cart/add.js',data:jQuery(form).serialize(),dataType:'json',success:function(line_item){ if(window.Shopify&&typeof Shopify.showAddToast==='function'){ } onItemAdded(); }}); }
      document.addEventListener('submit', function(e){ if(isAddToCartForm(e.target)) handleSubmit(e); }, true);
    })();